const cacheKeys = {
  profile: 'profile',
  balanceTotal: 'balanceTotal',
  asset: 'asset',
  assetQuotes: 'assetQuotes',
  assetTableData: 'assetTableData',
  withdrawalFees: 'withdrawalFees',
  withdrawalLimits: 'withdrawalLimits',
  depositLimits: 'depositLimits',
  mfaSecret: 'mfaSecret',
  notifications: 'notifications',
  notificationsUnreadCount: 'notificationsUnreadCount',
  downlineUsers: 'downlineUsers',
  userStatus: 'userStatus',
  tokenConvertEligibility: 'tokenConvertEligibility',
  compensationDownline: 'compensationDownline',
  compensationHistory: 'compensationHistory',
  compensationCreditHistory: 'compensationCreditHistory',
  directSales: 'directSales',

  mbaseBalanceTotal: 'mbaseBalanceTotal',
  userWalletAddress: 'userWalletAddress',
  userMiningAddress: 'userMiningAddress',
  convertedTokenList: 'convertedTokenList',
  checkSponsor: 'checkSponsor',
  welcomeBonusHistory: 'welcomeBonusHistory',
  userMbaseBonus: 'userMbaseBonus',
  sponsorBonus: 'sponsorBonus',
  tokenMining: 'tokenMining',
  verifierWallets: 'verifierWallets',
  promotionBonus: 'promotionBonus',
  mbaseWithdrawalFees: 'mbaseWithdrawalFees',
  ctpPrice: 'ctpPrice',

  // Rising fees cache keys
  stakeHolder: 'stackHolder',
  stakeToken: 'stackToken',

  userPromotionBonus: 'userPromotionBonus',
  userIncentiveAwarded: 'userIncentiveAwarded',
  userCtpBooster: 'userCtpBooster',
  fastStartBonus: 'fastStartBonus',

  // Christmas incentive
  christmasIncentives: 'christmasIncentives',

  interConnectedWallets: 'interConnectedWallets',
  interConnectAllow: 'interConnectAllow',
  interConnectedMiningWallets: 'interConnectedMiningWallets',
  interConnectProducedToken: 'interConnectProducedToken',
  interconnectFees: 'interconnectFees',
  interConnectSponsorBonus: 'interConnectSponsorBonus',
  interconnectVouchers: 'interconnectVouchers',

  purchasedTokens: 'purchasedTokens',
  purchasedTokenFees: 'purchasedTokenFees',

  // package purchase cache keys
  productPackages: 'productPackages',
  sharedPackages: 'sharedPackages',
  purchasedPackages: 'purchasedPackages',
  purchasedPackagesSponsorBonus: 'purchasedPackagesSponsorBonus',

  // annual percentage yield cache keys
  annualPackages: 'annualPackages',
  annualPurchased: 'annualPurchased',
  annualSharedPackages: 'annualSharedPackages',
  annualSponsorBonus: 'annualSponsorBonus',

  //Global Marketing Plan cache keys
  globalMarketingPackages: 'globalMarketingPackages',
  globalMarketingPurchased: 'globalMarketingPurchased',
  globalMarketingSharedPackages: 'globalMarketingSharedPackages',
  globalMarketingSponsorBonus: 'globalMarketingSponsorBonus',
  globalMarketingCurrentShared: 'globalMarketingCurrentShared',
  starPackagesProfit: 'starPackagesProfit',

  // Global Compensation APY Packages
  apyPackages: 'apyPackages',
  apyPurchasedPackages: 'apyPurchasedPackages',
  apySharedPackages: 'apySharedPackages',
  apyPackagesSponsorBonus: 'apyPackagesSponsorBonus',
  apyPackagesCurrentShared: 'apyPackagesCurrentShared',

  // Metaverse land
  metaverseLand: 'metaverseLand',
  purchasedMetaverseLand: 'purchasedMetaverseLand',
  sharedMetaverseLand: 'sharedMetaverseLand',
  metaverseLandSharePrice: 'metaverseLandSharePrice',

  // Legacy Wallets
  legacyWallets: 'legacyWallets',

  // Legacy Products
  legacyProductsSponsorBonuses: 'legacyProductsSponsorBonuses',

  userStatusWallets: 'userStatusWallets',

  userUnilevelTree: 'userUnilevelTree',

  //Global Compensation Plan (GCP) cache keys
  gcpCommissions: 'gcpCommissions',
  myDownlineDetails: 'myDownlineDetails',
  centerLevelDetails: 'centerLevelDetails',
  lastCommissions: 'lastCommissions',
  lastCommissionsDateRange: 'lastCommissionsDateRange',

  showPopUp: 'showPopUp',

  apyPayout: 'apyPayout',
  purchasedVime: 'purchasedVime',
  purchasedVimeMbase: 'purchasedVimeMbase',
  vimeSponsorBonus: 'vimeSponsorBonus',
  vimeCurrentShared : 'vimeCurrentShared',
  apyStarPayout:'apyStarPayout',
  purchasedCharacter: 'purchasedCharacter'
}

export default cacheKeys
